import { Action } from 'redux';
import type { CustomItemsInsightsReport } from 'model/CustomItemsInsightsReport';

export const CUSTOM_ITEMS_INSIGHTS_REPORT_GET_START = 'CUSTOM_ITEMS_INSIGHTS_REPORT_GET_START';
export const CUSTOM_ITEMS_INSIGHTS_REPORT_GET_SUCCESS = 'CUSTOM_ITEMS_INSIGHTS_REPORT_GET_SUCCESS';
export const CUSTOM_ITEMS_INSIGHTS_REPORT_GET_ERROR = 'CUSTOM_ITEMS_INSIGHTS_REPORT_GET_ERROR';

type CustomItemsInsightsGetStartAction = Action<typeof CUSTOM_ITEMS_INSIGHTS_REPORT_GET_START>;

interface CustomItemsInsightsGetSuccessAction extends Action<typeof CUSTOM_ITEMS_INSIGHTS_REPORT_GET_SUCCESS> {
    payload: {
        report: CustomItemsInsightsReport;
    };
}

type CustomItemsInsightsGetErrorAction = Action<typeof CUSTOM_ITEMS_INSIGHTS_REPORT_GET_ERROR>;

export type CustomItemsInsightsReportAction =
    | CustomItemsInsightsGetStartAction
    | CustomItemsInsightsGetSuccessAction
    | CustomItemsInsightsGetErrorAction;
